module.exports = __webpack_public_path__ + "static/media/no-res.4ae84619.png";